export default __webpack_public_path__ + "static/media/solucao-09.e83c84f7.webp";